import { Avatar } from '../../components/Avatar/Avatar'
import { Typography } from 'components/Typography'
import { getCapitalCharName } from '../../helper/common'
import { Avatar as AvatarType } from 'features/UserProfile/types'

export const UserHeader = ({
  user
}: {
  user: {
    first_name?: string
    last_name?: string
    avatar_logo?: AvatarType | null
  }
}) => {
  const capitalCharName = getCapitalCharName(
    user.first_name ?? '',
    user.last_name ?? ''
  )

  const name = [user.first_name, user.last_name].join(' ')
  return (
    <div className="row gap-16 align-center mt-16">
      <Avatar
        className="user-form_avatar-icon user-header-icon"
        name={capitalCharName}
        alt="User avatar"
        src={user.avatar_logo?.file_preview}
        size={64}
      />
      <Typography.Headline3>{name}</Typography.Headline3>
    </div>
  )
}
